module.exports = __webpack_public_path__ + "img/propnex_logo.a70af96a.png";